import { isAxiosError } from 'axios';

export enum ErrorMessage {
  AddFamilyMember = 'addFamilyMember request failed',
  DeclineStudentJoinOffer = 'declineStudentJoinOffer request failed',
  RemindLaterStudentJoinOffers = 'remindLaterStudentJoinOffers request failed',
  AcceptTermsAndConditions = 'acceptTermsAndConditions request failed',
  SyncProfiles = 'syncProfiles request failed',
  RefreshProfiles = 'refreshProfiles request failed',
  ResetUnseenEvents = 'resetUnseenEvents request failed',
  SwitchProfile = 'switchProfile request failed',
  TechnicalSupport = 'technicalSupport request failed',
  HideDashboardNotice = 'hideDashboardNotice request failed',
  CancelSmsSubscription = 'cancelSmsSubscription request failed',
  CancelCardSubscription = 'cancelCardSubscription request failed',
  SubscribeToSms = 'subscribeToSms request failed',
  StartBankPayment = 'startBankPayment request failed',
  RefreshUser = 'refreshUser request failed',
  ChangeUsername = 'changeUsername request failed',
  ChangeEmail = 'changeEmail request failed',
  ChangePassword = 'changePassword request failed',
  ChangePhone = 'changePhone request failed',
  ChangeAdvertising = 'changeAdvertising request failed',
  ChangeCommercialNews = 'changeCommercialNews request failed',
  ChangeNotificationSettings = 'changeNotificationSettings request failed',
  ChangeFollowUpStatus = 'changeFollowUpStatus request failed',
  MarkMailMessagesRead = 'markMailMessagesRead request failed',
  MarkAllMailMessagesRead = 'markAllMailMessagesRead request failed',
  DeleteMailMessages = 'deleteMailMessages request failed',
  RestoreMailMessages = 'restoreMailMessages request failed',
  PermanentlyDeleteMailMessages = 'permanentlyDeleteMailMessages request failed',
  SubmitNonAttendanceApplication = 'submitNonAttendanceApplication request failed',
  TokenizeExternalLink = 'tokenizeExternalLink request failed',
  UploadAttachment = 'uploadAttachment request failed',
  SaveMailDraft = 'saveMailDraft request failed',
  SendMailMessage = 'sendMailMessage request failed',
  SendHomeTaskMessage = 'sendHomeTaskMessage request failed',
  MarkSurveySeen = 'markSurveySeen request failed',
  StartSurvey = 'startSurvey request failed',
  AnswerSurveyQuestion = 'answerSurveyQuestion request failed',
  FinishSurvey = 'finishSurvey request failed',
  RespondToVideoMeeting = 'respondToVideoMeeting request failed',
  StudyYearPeriods = 'studyYearPeriods request failed',
  DownloadEvaluationReport = 'downloadEvaluationReport request failed',
  DownloadFinalEvaluationReport = 'downloadFinalEvaluationReport request failed',
  AcknowledgeIndividualSupportPlan = 'acknowledgeIndividualSupportPlan request failed',
  ApprovePreschoolEvaluation = 'approvePreschoolEvaluation request failed',
}

interface AxiosErrorResponseData {
  message?: string;
  error?: string;
  reason?: string;
  code?: string;
  type?: string;
}

const extractBackendReason = (error: unknown): string | undefined => {
  if (!isAxiosError<AxiosErrorResponseData>(error)) {
    return undefined;
  }

  const data = error.response?.data;

  return data?.message ?? data?.error ?? data?.reason ?? error.message;
};

export const getResponseErrorCode = (error: unknown): string | undefined => {
  if (!isAxiosError<AxiosErrorResponseData>(error)) {
    return undefined;
  }

  return error.response?.data?.code;
};

export const getResponseErrorType = (error: unknown): string | undefined => {
  if (!isAxiosError<AxiosErrorResponseData>(error)) {
    return undefined;
  }

  return error.response?.data?.type;
};

export const logRequestError = (
  message: ErrorMessage,
  error: unknown,
): void => {
  const backendReason = extractBackendReason(error);

  if (backendReason) {
    console.error(`${message}: ${backendReason}`, error);
    return;
  }

  console.error(message, error);
};
